module.exports = __webpack_public_path__ + "c41a1b39bbe537d6d88b6e322af7cb42.png";